import React, { useState, useEffect } from "react";
import { API_URL } from "../variables";
import axios from "axios";
import SectionLoader from "./SectionLoader";
import "../assets/styles/style.css";
import { $uploads, $imageError } from "../global";
// Separate Review component
const ReviewCard = ({ review }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="review-card">
      <p className={`review-text ${isExpanded ? "expanded" : ""}`}>
        {review.comment}
      </p>
      <button
        className="read-more-btn"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {isExpanded ? "show less" : "read more"}
      </button>
      <div className="review-author-info">
        <img
          src={$uploads(review.image)}
          alt={review.names}
          onError={(e) => {
            e.target.src = $imageError();
          }}
        />
        <div className="names-title">
          <h4>{review.names}</h4>
          <span>{review.title}</span>
        </div>
      </div>
      <div className="stars">
        {"★".repeat(review.rating)}
        <span className="rating-value">{review.rating}.0</span>
      </div>
    </div>
  );
};

const Reviews = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await axios.get(`${API_URL}/reviews/getAllReviews`);
        setReviews(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching reviews:", error);
        setError("Failed to load reviews");
        setLoading(false);
      }
    };

    fetchReviews();
  }, []);

  const handleScroll = (e) => {
    const element = e.currentTarget;
    const index = Math.round(element.scrollLeft / element.offsetWidth);
    setActiveIndex(index);
  };

  if (loading) return <SectionLoader />;
  if (error) return <div>{error}</div>;

  return (
    <section className="reviews-section">
      <div className="reviews-header">
        <h2>Reviews</h2>
      </div>
      <div className="reviews-grid" onScroll={handleScroll}>
        {reviews.map((review, index) => (
          <ReviewCard key={index} review={review} />
        ))}
      </div>
      <div className="slider-dots">
        {[0, 1, 2].map((dot) => (
          <span
            key={dot}
            className={`dot ${activeIndex === dot ? "active" : ""}`}
          />
        ))}
      </div>
    </section>
  );
};

export default Reviews;
